import type { App } from 'vue'
import { setupPermissionDirectives } from './permission'

/**
 * 注册所有全局指令
 */
export function setupDirectives(app: App) {
  setupPermissionDirectives(app)
}

export * from './permission'
